export default class Breadcrumb {
  public text: string = '';
  public href: string = '';
  public icon: string = '';
  public disabled: boolean = false;

  constructor(text = '', href = '', disabled = false, icon = '') {
    this.text = text;
    this.href = href;
    this.disabled = disabled;
    this.icon = icon;
  }
}
